import { render } from "./CustomerDetailImage.vue?vue&type=template&id=39742a22&scoped=true"
import script from "./CustomerDetailImage.vue?vue&type=script&lang=js"
export * from "./CustomerDetailImage.vue?vue&type=script&lang=js"

import "./CustomerDetailImage.vue?vue&type=style&index=0&id=39742a22&scoped=true&lang=css"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39742a22"]])

export default __exports__